import { render, staticRenderFns } from "./Ciaz2021.vue?vue&type=template&id=b7cabf32&"
import script from "./Ciaz2021.vue?vue&type=script&lang=ts&"
export * from "./Ciaz2021.vue?vue&type=script&lang=ts&"
import style0 from "./Ciaz2021.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports